import {Component, ElementRef, Renderer2} from '@angular/core';
import {SLASH} from '@shared/models/shared.model';
import { Breadcrumb, Category, Facet, FacetValue, TranslatePipe } from '@spartacus/core';
import { FacetListComponent, FacetService, FocusDirective, IconComponent, TabComponent } from '@spartacus/storefront';
import {Observable} from 'rxjs';
import {CurrentCategoryService} from '../../../category-information/service/current-category.service';
import { EfaFacetComponent } from '../efa-facet/efa-facet.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-efa-facet-list',
    templateUrl: './efa-facet-list.component.html',
    imports: [
        FocusDirective,
        IconComponent,
        TabComponent,
        EfaFacetComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class EfaFacetListComponent extends FacetListComponent {
  currentCategory$: Observable<Category> = this.currentCategoryService.get();

  constructor(
    protected facetService: FacetService,
    protected elementRef: ElementRef,
    protected renderer: Renderer2,
    protected currentCategoryService: CurrentCategoryService,
  ) {
    super(facetService, elementRef, renderer);
  }

  getVisibilityAugmentedFacet(
    facet: Facet,
    activeFacets: Breadcrumb[],
    currentCategory: Category,
  ): Facet {
    if (!facet.category) {
      return facet;
    }

    const currentCategoryPath: string = this.getPath(
      facet.values,
      currentCategory.code,
    );

    const currentCategoryPathDepth = this.getPathDepth(currentCategoryPath);

    const facetValueMap: Map<string, FacetValue[]> = new Map();
    const relevantFacetValues = facet.values.filter(facetValue =>
      facetValue.code === currentCategoryPath
      || facetValue.code.startsWith(currentCategoryPath)
      || currentCategoryPathDepth > this.getPathDepth(facetValue.code));


    //create map by parentpath
    for (const facetValue of relevantFacetValues) {
      const parentPath = this.getParentPathFromFacetValue(facetValue);
      if (!facetValueMap.has(parentPath)) {
        facetValueMap.set(parentPath, []);
      }
      facetValueMap.get(parentPath).push(facetValue);
    }

    //determine selected facet values to purge map from unselected facet values with the same parent
    const facetValuesToRemove: FacetValue[] = [];
    for (const path of facetValueMap.keys()) {
      const currentFacetValues = facetValueMap.get(path);
      const selectedFacetValues = currentFacetValues.filter(facetValue => facetValue.selected);

      if (selectedFacetValues.length > 0) {
        facetValueMap.set(path, selectedFacetValues); // remove all other subcategories of this parent
        console.log("set selected subcategory of parent", path, selectedFacetValues);
        const unselectedFacetValues = currentFacetValues.filter(facetValue => !facetValue.selected);

        facetValuesToRemove.push(...unselectedFacetValues);
        unselectedFacetValues.forEach(facetValue => {
          if (facetValueMap.has(facetValue.code)) {
            facetValuesToRemove.push(...facetValueMap.get(facetValue.code));
          }
        });
      }
    }

    for (const facetValue of facetValuesToRemove) {
      facetValueMap.delete(facetValue.code);
      console.log("remove unselected subcategory", facetValue.code);
    }

    const visibleFacetValues: FacetValue[] = [];
    for (const path of facetValueMap.keys()) {
      const currentPathDepth = this.getPathDepth(path);
      const currentFacetValues = facetValueMap.get(path);
      const filteredValues = currentFacetValues.filter(facetValue => facetValue.selected)
      if (currentCategoryPathDepth > currentPathDepth) // display parent categories any way
      {
        visibleFacetValues.push(...currentFacetValues);
        console.log("Display all categories of parent", path, filteredValues);
      } else if (filteredValues.length > 0) //display selected category
      {
        visibleFacetValues.push(...filteredValues);
        console.log("Display selected categories of current path", path, filteredValues);
      } else { //display all categories of this depth and stop displaying deeper categories
        visibleFacetValues.push(...currentFacetValues);
        console.log("Display all categories of current path", path, currentFacetValues);
        break;
      }
    }

    return {...facet, values: visibleFacetValues};
  }

  private getPath(
    facetValues: FacetValue[],
    code: string,
  ): string {
    return facetValues.find((facetValue: FacetValue) =>
      facetValue.code.endsWith(SLASH + code),
    ).code;
  }


  private getPathDepth(path: string): number {
    return path.split(SLASH).length - 1;
  }

  private getParentPath(path: string): string {
    return path.substring(0, path.lastIndexOf(SLASH));
  }

  private getParentPathFromFacetValue(facetValue: FacetValue): string {
    return this.getParentPath(facetValue.code);
  }
}
